module.exports = __webpack_public_path__ + "static/media/Infernape_gaussian2.75fd0324.png";